/**
 * Access-grant persistence schema.
 *
 * Invariants:
 * - A grantee can hold at most one grant per `(resourceId, resourceType,
 *   resourceScope, granteeId, granteeType)` tuple.
 * - Role/scope semantics are validated by auth grant definitions at write time.
 *
 * @see `packages/core/docs/database.md`
 */
import { index, uniqueIndex, pgEnum, pgTable, text, uuid } from "drizzle-orm/pg-core";
import type { ResourceType, ResourceScope, Role } from "./definitions";
import { id } from "../../utils/sql";

export const granteeType = pgEnum("grantee_type", ["user", "group"]);

export const accessGrant = pgTable(
  "access_grant",
  {
    ...id,
    granteeId: uuid("grantee_id").notNull(),
    granteeType: granteeType("grantee_type").notNull(),
    resourceId: uuid("resource_id").notNull(),
    resourceType: text("resource_type").$type<ResourceType>().notNull(),
    resourceScope: text("resource_scope").$type<ResourceScope>().notNull(),
    role: text("role").$type<Role>().notNull(),
  },
  (t) => [
    index("grant_grantee_id_type").on(t.granteeId, t.granteeType),
    uniqueIndex("grant_resource_id_type_scope_grantee_id_type").on(
      t.resourceId,
      t.resourceType,
      t.resourceScope,
      t.granteeId,
      t.granteeType,
    ),
  ],
);
